module.exports = __webpack_public_path__ + "media/images/badges/stride/stride-logo-badge_active-4b92933cdbba2d1ce3bb3e94868e7d21.svg";